import {uuid} from 'uuidv4';
import Tone from 'tone';

class AutomationPoint {
    constructor(step, value) {
        this.step = step;
        this.value = value;
        this.id = uuid();
    }

    fromJson(json) {
        this.step = json.step;
        this.value = typeof (json.value) === 'string' ? new Tone.Time(json.value) : json.value;
        this.id = json.id;
        return this;
    }

    getCopy(copyId=true) {
        let point = new AutomationPoint()
            .fromJson(this.getJson());

        if (copyId) {
            point.id = this.id;
        } else {
            point.id = uuid();
        }
        return point;
    }

    getJson() {
        return {
            step: this.step,
            value: this.value === undefined ? undefined :
                this.value === null ? null : this.value.toNotation ? this.value.toNotation() : this.value,
            id: this.id,
        };
    }
}

export default AutomationPoint;
